import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4">
            <h5>About Vibex Media</h5>
            <p>We are a full-service digital advertising agency dedicated to helping brands reach their maximum potential through innovative strategies and creative solutions.</p>
            <div className="social-links mt-4">
              <a href="https://www.facebook.com/vmslabs/"><i className="fab fa-facebook-f"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
              <a href="https://www.instagram.com/vmsl.abs/?hl=en"><i className="fab fa-instagram"></i></a>
              <a href="https://www.linkedin.com/company/vmslabs-official/?viewAsMember=true"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>
          <div className="col-lg-2 col-md-6 mb-4">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/" className="text-white-50">Home</Link></li>
              <li className="mb-2"><Link to="/services" className="text-white-50">Services</Link></li>
              <li className="mb-2"><Link to="/portfolio" className="text-white-50">Portfolio</Link></li>
              <li className="mb-2"><Link to="/Blogs" className="text-white-50">Our Blogs</Link></li>
              <li className="mb-2"><Link to="/contact" className="text-white-50">Contact</Link></li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <h5>Our Services</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/our-services/advertisement" className="text-white-50">Advertisement</Link>
              </li>
              <li className="mb-2">
                <Link to="/our-services/marketing" className="text-white-50">Marketing</Link>
              </li>
              <li className="mb-2">
                <Link to="/our-services/press-release" className="text-white-50">Press Release</Link>
              </li>
              {/* <li className="mb-2"><a href="#" className="text-white-50">SEO Optimization</a></li>
              <li className="mb-2"><a href="#" className="text-white-50">Creative Design</a></li> */}
            </ul>
          </div>
          <div className="col-lg-3 mb-4">
            <h5>Contact Us</h5>
            <ul className="list-unstyled">
              <li className="mb-3"><i className="fas fa-phone me-2"></i>+613-915-9806</li>
              <li className="mb-3"><i className="fas fa-phone me-2"></i>+91 8384802754</li>
              <li className="mb-3"><i className="fas fa-envelope me-2"></i> contact@vibex.media</li>
              <li><i className="fas fa-clock me-2"></i> Mon-Fri: 9AM - 6PM</li>
            </ul>
          </div>
        </div>
        <div className="row copyright">
          <div className="col-12 text-center">
            <p className="mb-0">&copy; 2025 Vibex.Media. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 